module.exports = __webpack_public_path__ + "img/tassie3.4f1fbfb.jpg";